import { Clock, Headphones, Mail, MapPin, Phone } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SectionHeader from '../components/SectionHeader';
import ContactInquiryForm from '../components/ContactInquiryForm';
import PhoneCta from '../components/PhoneCta';
import CompanyAddress from '../components/CompanyAddress';
import { COMPANY_NAME, EMAIL, PHONE, SITE_NAME } from '../constants/site';

export default function SupportPage() {
  return (
    <>
      <Header />
      <section className="page-banner page-banner--compact">
        <div className="container">
          <SectionHeader
            eyebrow="Help centre"
            title="Contact Us"
            subtitle={`Reach the ${SITE_NAME} team 24/7 — call, email, or send your details below.`}
            light
          />
        </div>
      </section>
      <div className="container page-content-premium support-layout">
        <PhoneCta
          variant="promo"
          className="phone-cta--support support-layout__cta-full"
          badge="Priority support — answer in minutes"
          title="Call us now — 24/7 travel support"
          subtitle="Flights, hotels, cars, packages & cruises — one number."
        />
        <div className="panel-premium">
          <ContactInquiryForm
            className="support-form contact-inquiry-form"
            subject={`${SITE_NAME} — Contact / support request`}
            submitLabel="Send message"
            showTopic
            showMessage
            messageRequired
            successMessage={`Thank you. A ${SITE_NAME} support agent will respond shortly.`}
          />
        </div>
        <aside className="support-cards">
          <div className="support-card">
            <Phone size={22} aria-hidden />
            <h3>Call us 24/7</h3>
            <a href={`tel:${PHONE.replace(/[^\d+]/g, '')}`}>{PHONE}</a>
          </div>
          <div className="support-card">
            <Mail size={22} aria-hidden />
            <h3>Email</h3>
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
          </div>
          <div className="support-card">
            <Clock size={22} aria-hidden />
            <h3>Response time</h3>
            <p>Most inquiries answered within 15 minutes</p>
          </div>
          <div className="support-card support-card--accent">
            <Headphones size={22} aria-hidden />
            <h3>Operated by</h3>
            <p>{COMPANY_NAME}</p>
          </div>
          <div className="support-card">
            <MapPin size={22} aria-hidden />
            <h3>Office</h3>
            <p>
              <CompanyAddress as="span" />
            </p>
          </div>
        </aside>
      </div>
      <section className="container support-faq" id="faqs" aria-labelledby="support-faq-heading">
        <h2 id="support-faq-heading" className="support-faq__title">
          Frequently asked questions
        </h2>
        <div className="support-faq__grid">
          <details className="support-faq__item">
            <summary>Can I change or cancel my booking?</summary>
            <p>
              Yes, subject to your fare rules and supplier policies. See our{' '}
              <a href="/flight/cancellation-refund">Cancellation &amp; Refund Policy</a> or call us 24/7 for assistance.
            </p>
          </details>
          <details className="support-faq__item">
            <summary>When will I receive my confirmation?</summary>
            <p>
              Most confirmations arrive by email within minutes. Complex itineraries may take up to 24 hours. Check spam
              folders and My Bookings if needed.
            </p>
          </details>
          <details className="support-faq__item">
            <summary>What fees may apply to my booking?</summary>
            <p>
              Service fees, taxes, and carrier charges are disclosed at checkout. Review our{' '}
              <a href="/flight/service-fees">Service Fees</a> and <a href="/flight/fare-disclosure">Fare Disclosure Policy</a>.
            </p>
          </details>
          <details className="support-faq__item">
            <summary>How do I manage an existing reservation?</summary>
            <p>
              Visit <a href="/flight/bookings">Manage Booking</a> or contact support with your confirmation number and passenger
              names.
            </p>
          </details>
        </div>
      </section>
      <Footer />
    </>
  );
}
